import React from 'react';
import "./scripts/i18n";
import './css/styles.css'
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import App from './scripts/app';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);